import { render, staticRenderFns } from "./ClaimMain.vue?vue&type=template&id=f0861cfe"
import script from "./ClaimMain.vue?vue&type=script&lang=js"
export * from "./ClaimMain.vue?vue&type=script&lang=js"
import style0 from "./ClaimMain.vue?vue&type=style&index=0&id=f0861cfe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports